import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import ContactModal from '../../components/feature/ContactModal';
import SEO from '../../components/feature/SEO';
import PlaceholderPage from '../../components/feature/PlaceholderPage';

const stats = [
  { value: '$16M+', label: 'In fraud prevented' },
  { value: '1,800+', label: 'Businesses protected' },
  { value: '99.999%', label: 'Cryptographic security' },
  { value: '5 mins', label: 'Setup time' },
];

const painPoints = [
  {
    icon: 'ri-mail-line',
    title: 'Intercepted invoices',
    description: 'Cybercriminals intercept your invoice emails and replace your bank details before the email reaches your client.',
  },
  {
    icon: 'ri-file-copy-line',
    title: 'Perfect forgeries',
    description: 'Fraudsters replicate your exact invoice layout — same logo, same wording — with their account details substituted in.',
  },
  {
    icon: 'ri-bank-line',
    title: 'Misdirected payments',
    description: 'Your client pays in good faith. The money lands in a fraudster\'s account. You discover it weeks later — and the relationship is damaged.',
  },
];

const accountantBenefits = [
  'Offer a differentiated, high-value service your competitors can\'t match',
  'Protect all your clients\' Xero invoices under one ProAdvisor plan',
  'Earn recurring commission as a XeroVerifier affiliate partner',
  'Up to 10 client Xero realms under a single subscription',
  'White-glove onboarding support for you and your clients',
  'Be the trusted advisor who prevented a fraud — not the one who missed it',
];

const partnerBenefits = [
  'Refer clients and earn 25% commission in year one, 15% recurring',
  'Co-branded marketing materials provided at no cost',
  'Dedicated partner portal and performance dashboard',
  '$500 bonus when you reach 10 active client referrals',
  'No upfront costs or minimum commitments',
  'Monthly commission payments, fully transparent reporting',
];

const testimonials = [
  {
    quote: "One of my clients was nearly defrauded by a $28,000 fake invoice. XeroVerifier's bioQR stamp would have stopped it cold. I've now rolled it out across all my Xero clients.",
    name: 'Sarah M.',
    role: 'CPA, Small Business Practice',
  },
  {
    quote: "As a bookkeeper managing 30 clients, the ProAdvisor plan is an absolute no-brainer. The protection it provides and the peace of mind for my clients is worth every cent.",
    name: 'James T.',
    role: 'Senior Bookkeeper & Xero ProAdvisor',
  },
  {
    quote: "I read Harry\'s post, installed it the same day. Setup took four minutes. That was three months ago — I\'ve stamped 340 invoices since. Not a single fraud attempt has got through.",
    name: 'Michelle R.',
    role: 'Freelance Consultant & Xero User',
  },
];

const steps = [
  {
    number: '01',
    title: 'Install the Chrome Extension',
    description: 'A 60-second install into your Chrome browser. No IT department needed.',
  },
  {
    number: '02',
    title: 'Connect to Xero Online',
    description: 'One-click authorisation. XeroVerifier integrates directly — no data ever leaves your environment.',
  },
  {
    number: '03',
    title: 'Send invoices as normal',
    description: 'Every invoice you send is automatically stamped with an AES-256 encrypted bioQR verification code.',
  },
  {
    number: '04',
    title: 'Your clients verify in seconds',
    description: 'Clients scan the QR code or use the free browser extension. Instant confirmation — this is genuine, from you, untampered.',
  },
];

export default function LinkedInLanding() {
  return (
    <>
      <SEO
        title="XeroVerifier for LinkedIn Visitors – Invoice Fraud Protection"
        description="Discover XeroVerifier, the Xero extension that stamps invoices with cryptographic verification codes to prevent invoice fraud and build client trust."
        keywords="XeroVerifier LinkedIn, invoice fraud protection, Xero security extension, verify Xero invoices, business invoice fraud"
        canonical="/from-linkedin"
        schema={{
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: 'XeroVerifier for LinkedIn Visitors',
          description: 'XeroVerifier invoice fraud protection for LinkedIn visitors.',
          url: `${import.meta.env.VITE_SITE_URL || ''}/from-linkedin`,
        }}
      />
      <PlaceholderPage
        title="Welcome"
        icon="ri-linkedin-box-line"
        description="Thank you for visiting from LinkedIn. This page is coming soon."
      />
    </>
  );
}
